import React, { useEffect, useState } from 'react';
import ProgressiveForm from 'components/Form/ProgressiveForm';

import { Container } from './styles';

const HeroInlineProgressiveForm = ({ buttonColor, notificationMessage, revealProps, theme }) => {
  const [formValues, setFormValues] = useState({});

  useEffect(() => {
    setFormValues({
      ...JSON.parse(localStorage.getItem('ProgressiveForm')),
    });
  }, []);

  const onSubmit = data => {
    localStorage.setItem('ProgressiveForm', JSON.stringify(data));
    setFormValues(data);
  };

  return Object.keys(formValues).length < 2 ? (
    <Container theme={theme}>
      <ProgressiveForm
        buttonColor={buttonColor}
        data-position="Hero"
        buttonTitle={['Subscribe', 'Submit']}
        enableNotification={true}
        notificationMessage={notificationMessage}
        className="hero-inline-progressive-form"
        revealProps={revealProps}
        formValues={formValues}
        onSubmit={onSubmit}
      />
    </Container>
  ) : null;
};

HeroInlineProgressiveForm.defaultProps = {
  buttonColor: 'blue',
  notificationMessage:
    'Thanks for subscribing! Please check your mail to confirm your subscription',
  revealProps: {
    styles: 'hero-inline-progressive-form--legal-info',
    content: (
      <>
        By entering your information above and clicking this button, you agree that we may contact
        you at the phone number or email address you provide in this form. Our{' '}
        <a href="/terms-of-use" target="_blank">
          Terms of Use{' '}
        </a>
        and{' '}
        <a href="/privacy-policy" target="_blank">
          Privacy Policy{' '}
        </a>
        apply.
      </>
    ),
  },
};

export default HeroInlineProgressiveForm;
